import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { useSearchParams, useNavigate } from 'react-router';
import { ReportActionActionName } from '@amzn/handshake-painter-typescript-client/v1';
import { PrimeButton, OrangeButton } from 'src/common/buttons';
import { useAppInit, useReportAction } from 'src/hooks';
import { sendAuthMessage } from 'src/utils/messages';
import { AuthStatus } from 'src/utils/auth';
import { useAnalyticsContext } from 'src/common/metrics/AnalyticsContext';
import { routes } from 'src/utils/routes';
import { addProductDetailsToBag } from 'src/utils/bagUtils';
export const ContinueButton = ({ isDisabled, quantity, isPrime, product, source, dataTestId, }) => {
    const [bundle, isBundleLoading] = useBundle('pages.productDetails');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const rumClient = useAnalyticsContext();
    const { data: appData } = useAppInit();
    const isUserLinked = !!(appData === null || appData === void 0 ? void 0 : appData.linked);
    const { mutate: reportAction } = useReportAction();
    const Button = isPrime ? PrimeButton : OrangeButton;
    const onContinueClick = () => {
        // Do we throw or console.error?
        if (!product) {
            throw new Error('Product details missing.');
        }
        // Report button click action
        reportAction({
            actionName: ReportActionActionName.BuyButtonClick,
            source,
        });
        // Add current product to bag
        addProductDetailsToBag(product, quantity);
        // TODO: Prefetch previewOrder API, add spinner to button, navigate on success or handle error appropriately
        const previewPage = `${routes.previewOrderPage}?${searchParams.toString()}`;
        if (isUserLinked) {
            navigate(previewPage);
        }
        else {
            sendAuthMessage(rumClient, AuthStatus.AUTHENTICATE, previewPage, source);
        }
    };
    if (isBundleLoading)
        return null;
    return (_jsx(Button, { disabled: isDisabled, onClick: onContinueClick, "data-testid": dataTestId, children: bundle.getMessage(isPrime ? 'continueWithPrime' : 'continueWithAmazon') }));
};
